export default {
    getPositionList: '/auth/position/list', //表格查询获取部门列表
    getStatusMarkFunctional: '/auth/position/selected/satisfied', //获取职位状态，标识，职能包
    getPosTypeRank: '/auth/position/selected/rankAndType', //获取职级、职位类型
    deletPosition: '/auth/position/deletePosition', //职位删除
    updatePosition: '/auth/position/updatePosition', //职位编辑
    addPosition: '/auth/position/addPosition', //职位新增
    startPosition: '/auth/position/reusing', //职位启用
    stopPosition: '/auth/position/stopUsing', //职位停用
    getPositionDetail: '/auth/position/getDetail', //获取职位详情
    getFunBindList:'/auth/position/getFunctionsByPositionId', //获取职能绑定列表
    getFunListByDept:'/auth/position/function/deptId/systemId/types', //获取部门下的职能包
    bindFunctional:'/auth/position/functional/bind', //职能包绑定
    deleteFunBind:'/auth/position/function/delete', //职能包绑定删除
    getUserList:'/auth/position/user/list', //获取用户列表
    getOrgListByOrgType:'/auth/organization/orgNames', //根据组织类型获取组织
    getDeptByOrgType:'/auth/token/condition/positionDepartment', //根据组织类型获取部门
    getPositionByDept:'/auth/position/dept/list', //根据部门机构获取职位
};


// WEBPACK FOOTER //
// ./src/api/positionDetail.js